/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderMonthAggregateDto } from './OrderMonthAggregateDto';
import {
    OrderMonthAggregateDtoFromJSON,
    OrderMonthAggregateDtoFromJSONTyped,
    OrderMonthAggregateDtoToJSON,
    OrderMonthAggregateDtoToJSONTyped,
} from './OrderMonthAggregateDto';
import type { OrderMinimalDto } from './OrderMinimalDto';
import {
    OrderMinimalDtoFromJSON,
    OrderMinimalDtoFromJSONTyped,
    OrderMinimalDtoToJSON,
    OrderMinimalDtoToJSONTyped,
} from './OrderMinimalDto';

/**
 * 
 * @export
 * @interface BusinessUnitTreeNodeExtendedDto
 */
export interface BusinessUnitTreeNodeExtendedDto {
    /**
     * 
     * @type {string}
     * @memberof BusinessUnitTreeNodeExtendedDto
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnitTreeNodeExtendedDto
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnitTreeNodeExtendedDto
     */
    code: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnitTreeNodeExtendedDto
     */
    fullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnitTreeNodeExtendedDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnitTreeNodeExtendedDto
     */
    parentId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BusinessUnitTreeNodeExtendedDto
     */
    ownOrderCount: number;
    /**
     * 
     * @type {number}
     * @memberof BusinessUnitTreeNodeExtendedDto
     */
    ownOrderAmount: number;
    /**
     * 
     * @type {Array<OrderMonthAggregateDto>}
     * @memberof BusinessUnitTreeNodeExtendedDto
     */
    ownMonthlyAggregates?: Array<OrderMonthAggregateDto> | null;
    /**
     * 
     * @type {number}
     * @memberof BusinessUnitTreeNodeExtendedDto
     */
    totalOrderCount: number;
    /**
     * 
     * @type {number}
     * @memberof BusinessUnitTreeNodeExtendedDto
     */
    totalOrderAmount: number;
    /**
     * 
     * @type {Array<OrderMonthAggregateDto>}
     * @memberof BusinessUnitTreeNodeExtendedDto
     */
    totalMonthlyAggregates?: Array<OrderMonthAggregateDto> | null;
    /**
     * 
     * @type {Array<BusinessUnitTreeNodeExtendedDto>}
     * @memberof BusinessUnitTreeNodeExtendedDto
     */
    children?: Array<BusinessUnitTreeNodeExtendedDto> | null;
    /**
     * 
     * @type {Array<OrderMinimalDto>}
     * @memberof BusinessUnitTreeNodeExtendedDto
     */
    orders?: Array<OrderMinimalDto> | null;
}

/**
 * Check if a given object implements the BusinessUnitTreeNodeExtendedDto interface.
 */
export function instanceOfBusinessUnitTreeNodeExtendedDto(value: object): value is BusinessUnitTreeNodeExtendedDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('ownOrderCount' in value) || value['ownOrderCount'] === undefined) return false;
    if (!('ownOrderAmount' in value) || value['ownOrderAmount'] === undefined) return false;
    if (!('totalOrderCount' in value) || value['totalOrderCount'] === undefined) return false;
    if (!('totalOrderAmount' in value) || value['totalOrderAmount'] === undefined) return false;
    return true;
}

export function BusinessUnitTreeNodeExtendedDtoFromJSON(json: any): BusinessUnitTreeNodeExtendedDto {
    return BusinessUnitTreeNodeExtendedDtoFromJSONTyped(json, false);
}

export function BusinessUnitTreeNodeExtendedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessUnitTreeNodeExtendedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'code': json['code'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'description': json['description'] == null ? undefined : json['description'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'ownOrderCount': json['ownOrderCount'],
        'ownOrderAmount': json['ownOrderAmount'],
        'ownMonthlyAggregates': json['ownMonthlyAggregates'] == null ? undefined : ((json['ownMonthlyAggregates'] as Array<any>).map(OrderMonthAggregateDtoFromJSON)),
        'totalOrderCount': json['totalOrderCount'],
        'totalOrderAmount': json['totalOrderAmount'],
        'totalMonthlyAggregates': json['totalMonthlyAggregates'] == null ? undefined : ((json['totalMonthlyAggregates'] as Array<any>).map(OrderMonthAggregateDtoFromJSON)),
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(BusinessUnitTreeNodeExtendedDtoFromJSON)),
        'orders': json['orders'] == null ? undefined : ((json['orders'] as Array<any>).map(OrderMinimalDtoFromJSON)),
    };
}

export function BusinessUnitTreeNodeExtendedDtoToJSON(json: any): BusinessUnitTreeNodeExtendedDto {
    return BusinessUnitTreeNodeExtendedDtoToJSONTyped(json, false);
}

export function BusinessUnitTreeNodeExtendedDtoToJSONTyped(value?: BusinessUnitTreeNodeExtendedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
        'fullName': value['fullName'],
        'description': value['description'],
        'parentId': value['parentId'],
        'ownOrderCount': value['ownOrderCount'],
        'ownOrderAmount': value['ownOrderAmount'],
        'ownMonthlyAggregates': value['ownMonthlyAggregates'] == null ? undefined : ((value['ownMonthlyAggregates'] as Array<any>).map(OrderMonthAggregateDtoToJSON)),
        'totalOrderCount': value['totalOrderCount'],
        'totalOrderAmount': value['totalOrderAmount'],
        'totalMonthlyAggregates': value['totalMonthlyAggregates'] == null ? undefined : ((value['totalMonthlyAggregates'] as Array<any>).map(OrderMonthAggregateDtoToJSON)),
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(BusinessUnitTreeNodeExtendedDtoToJSON)),
        'orders': value['orders'] == null ? undefined : ((value['orders'] as Array<any>).map(OrderMinimalDtoToJSON)),
    };
}

